namespace $.$$ {
	export class $shm_hitalama_map_page_dragger extends $.$shm_hitalama_map_page_dragger {

		widget( next?: $shm_hitalama_map_widget_float | null ): $shm_hitalama_map_widget_float | null {
			if( next !== undefined ) return this.widget_raw( next )
			return this.widget_active()
		}

		@ $mol_mem
		widget_active(): $shm_hitalama_map_widget_float | null {
			if( this.Map_page().interaction_locked() ) return null
			if( !this.Map_page().map().can_change() ) return null
			const widget = this.widget_raw() as $shm_hitalama_map_widget_float | null ?? this.set_pos()?.widget ?? null
			if( !widget || this.Map_page().Pane().selecting() ) return null
			const page = this.Map_page() as $shm_hitalama_map_page
			if( !page.selected_links_live().has( widget.widget().link().str ) ) return null
			const [ cursor_x, cursor_y ] = page.pointer_pos()
			const [ shift_x, shift_y ] = page.shift()
			const zoom = page.zoom()
			const left = widget.left() * zoom + shift_x
			const right = ( widget.left() + widget.width() ) * zoom + shift_x
			const top = widget.top() * zoom + shift_y
			const bottom = ( widget.top() + widget.height() ) * zoom + shift_y
			const near_x = Math.min( Math.abs( cursor_x - left + 1 ), Math.abs( cursor_x - right - 1 ) ) <= 60
			const near_y = Math.min( Math.abs( cursor_y - top - 1 ), Math.abs( cursor_y - bottom + 1 ) ) <= 60
			return near_x && near_y ? widget : null
		}
		
		left(): string {
			return this.x() + 'px'
		}
		top(): string {
			return this.y() + 'px'
		}

		@ $mol_mem
		x( next?: number ): number {
			const widget = this.widget()
			return widget
				? this.anchor_hor() == 'right'
					? widget.left()
					: widget.left()+widget.width()
				: 0
		}

		@ $mol_mem
		y( next?: number ): number {
			const widget = this.widget()
			return widget
				? this.anchor_vert() == 'top'
					? widget.top()
					: widget.top()+widget.height()
				: 0
		}

		@ $mol_mem
		zoom_for_dragger() {
			return this.$.$shm_hitalama_settings.dragger_keep_size()
				? this.Map_page().zoom() : 1
		}

		anchor_hor() {
			return this.set_pos()?.anchor_hor ?? 'left'
		}

		anchor_vert() {
			return this.set_pos()?.anchor_vert ?? 'bottom'
		}

		@ $mol_mem
		set_pos() {
			const page = this.Map_page()
			if( page.Pane().selecting() ) return null
			if( page.some_transforming() ) return
			if( page.hovered_link() && page.Widget( page.hovered_link() ).widget().type() == 'iframe' ) return
			const selected_links = page.selected_links()

			const pointer_client_pos = page.Pane().pointer_client_pos()
			if( pointer_client_pos[0] === 0 && pointer_client_pos[1] === 0 ) return

			const [cursor_x,cursor_y] = page.pointer_pos()
			const [shift_x, shift_y] = page.shift()
			const zoom = page.zoom()

			const nearest = {
				x_dist: Infinity,
				y_dist: Infinity,
				widget: null as $shm_hitalama_map_widget_float | null,
				anchor_hor: 'right',
				anchor_vert: 'top',
			}

			const threshold = 60
			const outer_gap = 1

			page.widgets_view().map( view => view.Sub() as $shm_hitalama_map_widget_float ).forEach( widget => {
				if( widget.widget().locked() ) return
				if( selected_links.length > 1 && selected_links.some( link => link.str == widget.widget().link().str ) ) return

				const left = widget.left() * zoom + shift_x
				const top = widget.top() * zoom + shift_y
				const right = ( widget.left() + widget.width() ) * zoom + shift_x
				const bottom = ( widget.top() + widget.height() ) * zoom + shift_y

				const corners = [
					{
						test_x: left - outer_gap,
						test_y: top + outer_gap,
						anchor_hor: 'right',
						anchor_vert: 'top',
					},
					{
						test_x: right + outer_gap,
						test_y: top + outer_gap,
						anchor_hor: 'left',
						anchor_vert: 'top',
					},
					{
						test_x: left - outer_gap,
						test_y: bottom - outer_gap,
						anchor_hor: 'right',
						anchor_vert: 'bottom',
					},
					{
						test_x: right + outer_gap,
						test_y: bottom - outer_gap,
						anchor_hor: 'left',
						anchor_vert: 'bottom',
					},
				]

				corners.forEach( corner => {
					const x_dist = Math.abs( cursor_x - corner.test_x )
					if( x_dist > threshold ) return

					const y_dist = Math.abs( cursor_y - corner.test_y )
					if( y_dist > threshold ) return

					if( x_dist ** 2 + y_dist ** 2 < nearest.x_dist ** 2 + nearest.y_dist ** 2 ) {
						nearest.x_dist = x_dist
						nearest.y_dist = y_dist
						nearest.widget = widget
						nearest.anchor_hor = corner.anchor_hor
						nearest.anchor_vert = corner.anchor_vert
					}
				} )
			} )

			// Geometry is derived state, not an effect. Writing the chosen widget
			// from auto() invalidated an already-rendered child during graph checking.
			return nearest
		}

		pointerdown( event?: PointerEvent ) {
			const widget = this.widget()
			if( !widget || !event ) return

			widget.drag_pointerdown( event )
		}
		
		event() {
			return {
				... super.event(),
				contextmenu: ( event: Event )=> event.preventDefault(),
			}
		}

	}
}
